<div class="smooth-scrolling without-sub-header">

  <!-- shipping detail start -->

  <section class="shipping-detail p-80">
    <div class="mx-1485">
      <div class="row">
        <div class="col-lg-5">
          <div class="main-title">
            <h3 class="text-gradient">Shipping policy</h3>
          </div>
        </div>
        <div class="col-lg-7">
          <div class="shipping-content">
            <span>At ecommerce, we strive to provide a seamless and reliable shipping experience for our valued
              customers. Please read the following policy to understand the details regarding shipping
              methods, processing times, delivery estimates, and any additional information related to
              shipping.</span>
            <span><b>What is ecommerce’s Delivery Process?</b></span>
            <span>
              <ul>
                <li>Before packaging of any order, it is thoroughly inspected to ensure that the product/s
                  are in their perfect condition. Once they are approved in the final round of
                  examination, they are packed.</li>
                <li>Once packed, they are handed over to our trusted delivery service partners who
                  strive to reach your location as early as possible.</li>
                <li>If our delivery partners face any difficulty in figuring out your address or there’s any
                  delay in delivery, they might reach out to you.</li>
              </ul>
            </span>
            <span><b>What is the Processing Time?</b></span>
            <span>We like the eager you. We make every effort to process and dispatch your order promptly.
              Our standard processing time for orders is typically 1-3 business days. We always have
              products in our inventory but some products might need to be sourced directly from brands
              to ensure freshness, hence, there could be slight delay. Please note that processing times
              may vary during peak seasons, sales, holidays, or due to unforeseen circumstances. We
              appreciate your patience and understanding.</span>
            <span><b>How long will it take for my order to be delivered after processing?</b></span>
            <span class="mb-0">Excited to see your package of care? We understand.</span>
            <span>Once your order has been processed and shipped, the estimated delivery time will depend
              on your location. You can go to your orders on the website to check the latest delivery date.
              Please refer to the shipping carrier's tracking information which you might receive in the form
              of an sms, once the order is shipped, for the most accurate and up-to-date delivery
              estimates. While we strive to meet the estimated delivery times, unforeseen delays may
              occur that are beyond our control.</span>
            <span><b>What is the shipping cost?</b></span>
            <span>We do not charge any shipping cost on the order value above Rs. 499. However, the
              applicable shipping charges will be displayed during the checkout process before you
              finalise your order.</span>
            <span><b>Does ecommerce deliver internationally?</b></span>
            <span>We are glad you want us to go global. We are working on it. Currently, we do not offer
              international shipping.</span>
            <span><b>How do I track my order?</b></span>
            <span>Once your order is shipped, you will receive a shipping confirmation email/sms containing
              the tracking information. You can use it to monitor the progress of your shipment through the
              shipping carrier's website or tracking portal.</span>
            <span><b>What if my order is lost or damaged?</b></span>
            <span>We’re very sorry if that happens but in the unfortunate event that your package is lost during
              transit, please contact our customer support team immediately via email <a
                href="#">customer@ecommerce.com</a> or directly call 11200 58668. We will work diligently with the
                shipping carrier to resolve the issue and ensure you receive a satisfactory resolution. In case
                you receive a damaged product, you can call for an exchange through the website by going
                on your order page.</span>
            <span>Please note that it is essential to provide accurate and complete shipping information to
              ensure the successful delivery of your order. Please double-check your shipping address
              before finalising your purchase. ecommerce is not responsible for any delays or delivery issues
              caused by incorrect or incomplete address details provided by the customer.</span>
            <span>Certain products may have shipping restrictions due to their nature or legal regulations. We
              comply with all applicable laws and regulations related to shipping and will notify you if any
              restrictions prevent us from delivering certain items to your location.</span>
            <span>Please note that this shipping policy is subject to change without prior notice. We
              recommend reviewing the policy periodically for any updates or modifications.</span>
            <span>Thank you for choosing ecommerce. We appreciate your trust in our products and services.</span>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- shipping detail end -->
</div>
<!-- Footer START -->
<app-footer-bg></app-footer-bg>
<!-- Footer END -->